// /schedules DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정(레이아웃 결정성 확보, 헤더 잘림 해결).
// 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StatusChip } from "components/list";
import { ISchedule } from "../interfaces";
import { completeMeta, acceptMeta, resolveStatusMeta } from "./scheduleStatus";

// 최종 집계(숫자성) 컬럼 공통 스펙
const countColumn = (field: string, headerName: string): GridColDef<ISchedule> => ({
  field,
  headerName,
  type: "string",
  width: 88,
  minWidth: 80,
  align: "right",
  headerAlign: "right",
});

export const scheduleColumns: GridColDef<ISchedule>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "agentName",
    headerName: "현장요원 이름",
    width: 120,
    minWidth: 100,
  },
  { field: "agentCode", headerName: "현장요원 코드", width: 132, minWidth: 110 },
  {
    field: "centerName",
    headerName: "시설 이름",
    type: "string",
    width: 200,
    minWidth: 140,
    // 말줄임 툴팁은 DataGridPanel이 자동 적용
  },
  {
    field: "complete",
    headerName: "상태",
    type: "string",
    width: 96,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(completeMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  {
    field: "accept",
    headerName: "현장요원 수락",
    type: "string",
    width: 104,
    minWidth: 96,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(acceptMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  { field: "visitDate", headerName: "예정 방문날짜", type: "string", width: 116, minWidth: 108, align: "center", headerAlign: "center" },
  { field: "visitTime", headerName: "예정 방문시간", type: "string", width: 108, minWidth: 100, align: "center", headerAlign: "center" },
  { field: "visitDateFinal", headerName: "실제 방문날짜", type: "string", width: 116, minWidth: 108, align: "center", headerAlign: "center" },
  { field: "visitTimeFinal", headerName: "실제 방문시간", type: "string", width: 108, minWidth: 100, align: "center", headerAlign: "center" },
  countColumn("newChildrenFinal", "신규 아동"),
  countColumn("modChildrenFinal", "변경 아동"),
  countColumn("newDementiaFinal", "신규 치매"),
  countColumn("modDementiaFinal", "변경 치매"),
  countColumn("newIdisabledFinal", "신규 지적"),
  countColumn("modIdisabledFinal", "변경 지적"),
  { ...countColumn("absenceFinal", "결석"), width: 76, minWidth: 68 },
  { field: "documentSent", headerName: "서류 발송", type: "string", width: 96, minWidth: 88, align: "center", headerAlign: "center" },
  {
    field: "memo",
    headerName: "관리자 메모",
    type: "string",
    width: 240,
    minWidth: 160,
    sortable: false,
  },
];
